import { ScrapbookFile } from '@/api/scrapbook-data';
import ContentPreviewWraper from './ContentPreviewWraper';
import AnalyticsBuilderReportSection, {
  handleCopyToClipboard,
} from '@/components/analytics-builder/AnalyticsBuilderReportSection';

interface AnalyticsBuilderSectionPreviewProps {
  content: ScrapbookFile | null;
  onClose: () => void;
}
const AnalyticsBuilderSectionPreview = ({ content, onClose }: AnalyticsBuilderSectionPreviewProps) => {
  if (!content) return null;

  return (
    <ContentPreviewWraper
      content={content}
      onClose={onClose}
      title="Analytics Builder"
      subTitle={content?.content?.displayName}
      className="!max-h-[92vh] [&_.content-wrapper]:!pt-5"
      onCopy={() => handleCopyToClipboard(content.content)}
    >
      <div className="pb-5">
        <AnalyticsBuilderReportSection
          section={content.content}
          index={0}
          hideCopyToClipboardButton
          hideSaveToScrapbookButton
        />
      </div>
    </ContentPreviewWraper>
  );
};

export default AnalyticsBuilderSectionPreview;
